import React from 'react';
import buildPublicAssetUrl from '../utils/publicAssetUrl';

const DEFAULT_SUBTITLE = '\u0628\u0637\u0627\u0642\u0629 \u062a\u0639\u0631\u064a\u0641 \u0648\u0638\u064a\u0641\u064a\u0629';
const DEFAULT_FOOTNOTE = '\u0637\u0631\u0627\u0628\u0644\u0633 - \u0634\u0627\u0631\u0639 \u0639\u0645\u0631 \u0627\u0644\u0645\u062e\u062a\u0627\u0631 \u062c\u0648\u0627\u0631 \u062d\u062f\u064a\u0642\u0629 \u0634\u0627\u0631\u0639 \u0639\u0645\u0631 \u0627\u0644\u0645\u062e\u062a\u0627\u0631';
const DEFAULT_PHOTO_ALT = '\u0627\u0644\u0645\u0648\u0638\u0641';
const DEFAULT_EMPTY_NAME = '\u0628\u062f\u0648\u0646 \u0627\u0633\u0645';
const DEFAULT_ROLE = '\u0645\u0648\u0638\u0641';
const DEFAULT_PENDING_STATUS = '\u063a\u064a\u0631 \u0645\u0646\u0634\u0623\u0629 \u0628\u0639\u062f';
const LOGO_ALT = '\u0634\u0639\u0627\u0631 \u0627\u0644\u0634\u0631\u0643\u0629';
const QR_ALT = '\u0631\u0645\u0632 \u0627\u0644\u062a\u062d\u0642\u0642 QR';

const EmployeeBadgeCard = ({ detail, className = '' }) => {
  const company = detail?.company_identity || {};
  const user = detail?.user || {};
  const badge = detail?.badge || {};
  const display = detail?.display || {};
  const profileImageSrc = buildPublicAssetUrl(user.profile_image_url);
  const metaRows = Array.isArray(display.meta_rows) ? display.meta_rows : [];
  const isDisabled = badge.badge_status === 'disabled';

  return (
    <article className={`cr100-card ${className}`.trim()}>
      <header className="cr100-card__header">
        <div className="cr100-card__header-row">
          <div className="cr100-card__header-copy">
            <h3 className="cr100-card__company">{company.company_name}</h3>
          </div>
          {company.logo_data_uri ? (
            <img
              src={company.logo_data_uri}
              alt={LOGO_ALT}
              className="cr100-card__logo"
            />
          ) : null}
        </div>
      </header>

      <div className="cr100-card__divider" aria-hidden="true" />

      <section className="cr100-card__employee">
        <div className="cr100-card__photo-frame">
          {profileImageSrc ? (
            <img
              src={profileImageSrc}
              alt={`\u0635\u0648\u0631\u0629 ${user.full_name || DEFAULT_PHOTO_ALT}`}
              className="cr100-card__photo"
            />
          ) : (
            <div className="cr100-card__photo cr100-card__photo--fallback">
              {(user.full_name || '?').trim().charAt(0) || '?'}
            </div>
          )}
        </div>

        <h4 className="cr100-card__name">{user.full_name || DEFAULT_EMPTY_NAME}</h4>
        <p className="cr100-card__role">{user.job_title || user.role_label_ar || DEFAULT_ROLE}</p>

        <dl className="cr100-card__meta">
          {metaRows.map((row) => (
            <div key={row.key} className="cr100-card__meta-row">
              <dt>{row.label_ar}</dt>
              <dd dir={row.dir || 'ltr'}>{row.value || '-'}</dd>
            </div>
          ))}
        </dl>

        {display.company_address_line ? (
          <div className="cr100-card__address">{display.company_address_line}</div>
        ) : null}
      </section>

      <footer className="cr100-card__footer">
        <div className="cr100-card__footer-sep" aria-hidden="true" />
        {badge.qr_code_data_uri ? (
          <img
            src={badge.qr_code_data_uri}
            alt={QR_ALT}
            className="cr100-card__qr"
          />
        ) : (
          <div className="cr100-card__qr cr100-card__qr--placeholder">QR</div>
        )}
        <p className="cr100-card__footnote">{display.footer_note || DEFAULT_FOOTNOTE}</p>
      </footer>
    </article>
  );
};

export default EmployeeBadgeCard;
